import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import { createLogger } from "redux-logger";

import { persistStore, persistReducer } from "redux-persist"; // imports from redux-persist
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

const logger = createLogger();

const persistConfig = {
  // configuration object for redux-persist
  key: "root@@12345kepicker",
  storage, // define which storage to use

  // Custom save
  // Sadece bunu kayıtlı tutma
  // blacklist: ['isLogged'], // navigation will not be persisted

  // Sadece bunu kayıtlı tut
  // whitelist: ['isForgot'] // only navigation will be persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer); // create a persisted reducer

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  persistedReducer, // pass the persisted reducer instead of rootReducer to createStore
  composeEnhancers(applyMiddleware(thunk, logger)) // add any middlewares here
);

const persistor = persistStore(store); // used to create the persisted store, persistor will be used in the next step

export { store, persistor };
